import { put } from "./lib/request"

export default {
  update: (id, state) => put(`/books/${id}/sort`, {
    book: state
  })
}
